import BaseReportStore from './base-store'
import publisherStore from 'modules/offer/stores/publisher'
import allocationStore from 'modules/offer/stores/allocation'
import postStore from 'modules/cms/stores/post'
import siteStore from 'modules/admin/stores/site'
import metaFieldStore from 'modules/settings/stores/meta-field'

export default new class LossesStore extends BaseReportStore {
  constructor() {
    super(true)
  }

  endpointReport = 'losses'

  publisher = this.attachEntity(publisherStore, { params: { report: false } })
  allocation = this.attachEntity(allocationStore, { labelKey: 'description', params: { report: false } })
  site = this.attachEntity(siteStore)

  post = this.attachEntity(postStore, {
    params: this.postParams,
    labelKey: 'title',
    extra: ["content_type"],
    labelFn: (({ value, label, content_type }) => `[#${value}][${content_type}] - ${label}`)
  });

  metaField = this.attachEntity(metaFieldStore, {
    labelKey: 'key',
    valueKey: 'key',
    labelFn: ({ value }) => value,
  });

  get postParams() {
    return { report: false }
  }
  get data() {
    return this.collection.data
  }
  get sessions() {
    return this.data && this.data.total || ''
  }
  get completed() {
    return this.data && this.data.completed || ''
  }
  get revenue() {
    return this.data && this.data.revenue || ''
  }
  get cost() {
    return this.data && this.data.cost || ''
  }
  get margin() {
    return this.data && this.data.margin || ''
  }
}
